// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3bT3r","header":"ReportDetails_header__3Yd-W","title":"ReportDetails_title__zEBnR","left":"ReportDetails_left__KW4Pg"};